<template>
  <label :class="['ms-checkbox', {'event-none': readOnly}, dbOptionHeight]">
    <input
      v-show="isHideCheckbox"
      type="checkbox"
      class="ms-checkbox-control"
      :class="[customClass]"
      :readOnly="readOnly"
      :checked="isChecked"
      :value="isChecked"
      :disabled="isDisableCheckbox"
      v-on="listeners"
      v-tooltip="'Chọn'"
    />
    <!-- <span :class="['checkmark', { 'event-none': readOnly }]"></span> -->
    <span v-if="label && isShowLabel" class="ms-checkbox--text" :title="title ? title : ''">{{ label }}</span>
  </label>
</template>
<script>
import {defineComponent, computed, watch, ref, nextTick, getCurrentInstance} from 'vue';
export default defineComponent({
  name: 'msCheckbox',
  props: {
    /**
     * lấy dòng dữ liệu
     * NCQUYEN 29/11/2022
     */
    dataRow: {
      default: null,
      type: Object,
    },
    modelValue: {
      default: false,
      type: [Boolean, Number],
    },
    label: {
      default: null,
      type: String,
    },
    disabled: {
      default: false,
      type: [Boolean, Function, Number],
    },
    readOnly: {
      default: false,
      type: Boolean,
    },
    checked: {
      type: [Boolean, Number],
      default: false,
    },
    isShowLabel: {
      // có hiển thị label ko?
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: null,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    //Variable
    let focused = false;
    const isHideCheckbox = ref(true);
    const isDisableCheckbox = ref(false);
    const dbOptionHeight = computed(() => {
      return 'checkboxHeightValue' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });
    /**
     * Ẩn checkbox
     * NCQUYEN 29.11.2022
     */
    nextTick(() => {
      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      if (props.dataRow?.hasOwnProperty('_isHideCheckbox')) {
        if (!props.dataRow._isHideCheckbox) {
          isHideCheckbox.value = props.dataRow._isHideCheckbox;
        } else {
          isHideCheckbox.value = true;
        }
      } else {
        isHideCheckbox.value = true;
      }

      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      if (props.dataRow?.hasOwnProperty('_isDisabled')) {
        if (props.dataRow._isDisabled) {
          isDisableCheckbox.value = props.dataRow._isDisabled;
        } else {
          isDisableCheckbox.value = props.disabled;
        }
      } else {
        isDisableCheckbox.value = props.disabled;
      }
    });

    /**
     * bắt thay đổi của disabled
     */
    watch(
      () => props.disabled,
      () => {
        isDisableCheckbox.value = props.disabled;
      },
    );
    //Method
    const onFocus = () => {
      focused = true;
    };
    const onBlur = () => {
      focused = false;
    };

    /**
     * Hủy lan rộng event
     * HTHIEP 09.02.2022
     */
    const cancelEvent = e => {
      if (e) {
        if (typeof e.preventDefault === 'function') {
          e.preventDefault();
        }

        if (typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }

        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
    };

    // Event
    const listeners = computed(() => {
      return {
        click: event => {
          // emit('click', event);
        },
        input: () => {
          emit('update:modelValue', !props.modelValue);
        },
        change: event => {
          cancelEvent(event);
          emit('change', props.modelValue, props.label);
        },
        focus: event => {
          onFocus(event);
        },
        blur: event => {
          onBlur(event);
        },
      };
    });
    const isChecked = computed(() => props.modelValue || props.checked);

    return {
      focused,
      onFocus,
      onBlur,
      listeners,
      isChecked,
      isHideCheckbox,
      isDisableCheckbox,
      dbOptionHeight,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsCheckbox.scss';
</style>
